import React, { useEffect, useState } from 'react'
import { archiveGovtDept, archiveGovtJobs, getGovtDeptList, getGovtJobsList } from '../../../actions/utilitiesAction'
import GovtJobList from '../../../component/Utilities/GovernmentJobs/GovtJobsList'
import constant from '../../../constant'
import queryString from 'query-string'
import { useLocation } from "react-router-dom";


const GovtJobsList = () => {

    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [keyword, setKeyword] = useState('')
    const [showLoader, setShowLoader] = useState(false)
    const location = useLocation()

    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getGovtJobsLists(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage)
        document.title = constant.title.GovtJobsList
    }, [currentPage])

    const getGovtJobsLists = (page) => {
        setShowLoader(true)
        getGovtJobsList(page).then((res) => {
            setShowLoader(false)
            setList(res.result.res)
            setCount(res.result.res1.total)
        }).catch((err) => {
            alert(err)
        })

    }
    const updateStatus = (model) => {
        archiveGovtJobs(model).then((res) => {
            if (res.status) {
                getGovtJobsLists(currentPage)
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }
    return (
        <React.Fragment>
            <GovtJobList
                list={list}
                updateStatus={updateStatus}
                getGovtJobsLists={(page => getGovtJobsLists(page))}
                count={count}
                setPage={setCurrentPage}
                showLoader={showLoader}
                cpage={currentPage}
            />
        </React.Fragment>
    )
}
export default GovtJobsList;